import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { genres, heroImage } from "@/mocks/comics";

const stats = [
  { value: "1200+", label: "连载作品" },
  { value: "120+", label: "每日更新话数" },
  { value: "860万+", label: "追更读者" },
];

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/latest?q=${encodeURIComponent(q)}` : "/latest");
  };

  return (
    <section className="relative w-full min-h-[640px] md:h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="天天漫画网 - 海量人气连载漫画每日更新"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-20 pb-16 text-center">
        <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-white/10 text-background-100 text-xs md:text-sm border border-white/20 backdrop-blur-sm">
          <i className="ri-flashlight-fill text-accent-300"></i>
          今日已更新 120+ 话，持续上线中
        </span>

        <h1 className="mt-6 font-heading text-3xl md:text-6xl text-background-50 leading-tight">
          今天，想追哪部漫画？
        </h1>
        <p className="mt-5 max-w-2xl mx-auto text-background-200 text-sm md:text-lg leading-relaxed">
          天天漫画网每日更新海量人气连载漫画，今日最新话抢先看。热门日漫、国漫持续上线，追更不迷路，告别漫长等待。
        </p>

        <form
          onSubmit={handleSearch}
          className="mt-8 max-w-xl mx-auto flex flex-col sm:flex-row gap-2 items-stretch bg-background-50 rounded-full p-1.5 shadow-lg"
        >
          <div className="flex items-center gap-2 flex-1 px-3">
            <i className="ri-search-line text-primary-500 text-lg"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="输入漫画名称搜索最新话"
              className="w-full h-10 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </div>
          <button
            type="submit"
            className="h-11 sm:h-10 px-6 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap flex items-center justify-center gap-1.5 cursor-pointer hover:bg-primary-600 transition-colors"
          >
            立即搜索
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          {genres.slice(0, 6).map((g) => (
            <a
              key={g.name}
              href="#genres"
              className="px-3 py-1.5 rounded-full text-xs text-background-200 bg-white/10 border border-white/15 hover:bg-white/20 transition-colors"
            >
              {g.name}
            </a>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-3 max-w-lg mx-auto gap-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-2xl bg-white/10 border border-white/15 backdrop-blur-sm px-3 py-4">
              <div className="font-heading text-xl md:text-3xl text-accent-300">{s.value}</div>
              <div className="mt-1 text-xs text-background-200">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}